<template>
  <div id="listagem-solicitacao">
    <div class="func-historico" v-if="listaInterna.length || listaExterna.length">
<!--      fixme Ajustar os filtros na proxima tarefa -->
      <div class="filters"
           v-if="false"
      >
        <filtros
          :classe="'btn-filter'"
          :name="'Filtros'"
          v-on:clickButton="showDialog = true"
        />
        <filterDialog
          :componentList="inputJson"
          :open.sync="showDialog"
          :title="title"
        />
        <filtros
          v-for="(filtro,index) in filtros"
          :key="index"
          :classe=" filtro.active ? 'btn-filter-ativo' : 'btn-filter'"
          :name="filtro.name"
        />
      </div>
        <div
          v-for="(card, index) of contratosMapData"
          :key="index"
          style="margin-top: 5px; cursor:pointer;"
        >
          <div
            v-if="card.cardExterno"
          >
            <slot
              name="externo"
              :card="card"
            />
          </div>

          <div
            v-else
          >
            <slot
              name="interno"
              :card="card"
            />
          </div>
        </div>
    </div>
    <ErrorVazio
      style="margin-top: 100px;"
      v-if="!listaExterna.length && !listaInterna.length"
      :show-btn="false"
    />
  </div>
</template>
<script>
import Filtros from '@/components/buttons/Filtros.vue'
import StatusItem from '@/components/listagemColumn/StatusItem.vue'
import DataItem from '@/components/listagemColumn/DataItem.vue'
import FilterDialog from '@/components/filterDialog/FilterDialog'
import { mapGetters } from 'vuex'
import OcorrenciaItem from '@/components/listagemColumn/OcorrenciaItem'
import { mapSectionListByContrato } from '@/components/TemplateSolicitacao/TemplateSolicitacaoHelpers'
import ErrorVazio from '@/components/Error/ErrorVazio'

export default {
  name: 'ComponenteSolicitacaoHistorico',
  components: {
    ErrorVazio,
    Filtros,
    FilterDialog
  },
  data () {
    return {
      filtros: [
        {
          active: true,
          name: 'Agrupar contatos'
        },
        {
          active: false,
          name: 'periodo'
        },
        {
          active: false,
          name: 'Localização'
        },
        {
          active: false,
          name: 'Ordenar'
        }
      ],
      columns: [
        {
          field: 'categoria',
          component: OcorrenciaItem
        },
        {
          field: 'situacao',
          component: StatusItem,
          title: 'Situação'
        },
        {
          field: 'data_registro',
          component: DataItem,
          title: 'Data solicitação'
        }
      ],
      title: 'Filtros',
      // language=JSON
      inputText: `[
        {
          "title": "Ordenação",
          "type": "radio",
          "default": {
            "name": "Padrão",
            "id": 1
          },
          "elements": [
            {
              "name": "Padrão",
              "id": 1
            },
            {
              "name": "Ordenação alfabética (A-Z)",
              "id": 2
            },
            {
              "name": "Mais novos Primeiro",
              "id": 3
            },
            {
              "name": "Maior Valor",
              "id": 4
            }
          ]
        },
        {
          "title": "Período",
          "type": "periodo",
          "default": {
            "name": "30 Dias",
            "periodo": 30,
            "id": 3
          },
          "hasOthers": true,
          "elements": [
            {
              "name": "180 Dias",
              "periodo": 180,
              "id": 1
            },
            {
              "name": "90 Dias",
              "periodo": 90,
              "id": 2
            },
            {
              "name": "30 Dias",
              "periodo": 30,
              "id": 3
            }
          ]
        },
        {
          "title": "Situação",
          "elements": [
            {
              "color": "#18DE18",
              "name": "Aprovado",
              "id": 1
            },
            {
              "color": "#30A9EA",
              "name": "Liberado",
              "id": 2
            },
            {
              "color": "#EABD2A",
              "name": "Pendente",
              "id": 3
            },
            {
              "color": "#F74444",
              "name": "Negado",
              "id": 4
            },
            {
              "color": "'#FF0000'",
              "name": "Finalizado",
              "id": 5
            }
          ]
        },
        {
          "title": "Contratos",
          "elements": [
            {
              "name": "Plano Gold Família",
              "id": 1
            },
            {
              "name": "Plano Empresarial",
              "id": 2
            },
            {
              "name": "Plano Empresarial",
              "id": 3
            }
          ]
        }
      ]
      `,
      outputJson: {},
      showDialog: false
    }
  },
  props: {
    funcionalidade: {
      type: Object,
      default: () => ({})
    },
    listaExterna: {
      type: Array,
      default: () => []
    },
    listaInterna: {
      type: Array,
      default: () => []
    },
    chaveExterna: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters('Login', ['user', 'contratos']),
    lista () {
      if (Array.isArray(this.listaExterna) && this.listaExterna.length > 0) {
        const mesclador = {}

        this.listaInterna.forEach((item) => {
          const numeroContrato = item.numeroContrato || 'n/a'
          mesclador[numeroContrato] = item
        })

        this.listaExterna.forEach((item) => {
          const numeroContrato = item.numeroContrato || 'n/a'
          const itemElement = item[this.chaveExterna]

          if (!mesclador[numeroContrato]) {
            mesclador[numeroContrato] = {
              numeroContrato: numeroContrato,
              ocorrencias: itemElement
            }
          } else {
            mesclador[numeroContrato].ocorrencias = mesclador[numeroContrato].ocorrencias.concat(itemElement)

            mesclador[numeroContrato].ocorrencias.sort((a, b) => {
              try {
                return Number.parseInt(b.data_registro) - Number.parseInt(a.data_registro)
              } catch (e) {
                return -1
              }
            })
          }
        })

        const listaMesclada = []

        Object.keys(mesclador).forEach((key) => {
          listaMesclada.push(mesclador[key])
        })

        return listaMesclada
      }

      return this.listaInterna
    },
    numeroContrato () {
      return this.$route.query.numeroContrato
    },
    contratosMapData () {
      let list = []
      if (this.contratosMap.length > 0) {
        this.contratosMap.forEach((value) => {
          list = list.concat(value.data)
        })

        return list
      }

      return []
    },
    contratosMap () {
      const contratosMap = mapSectionListByContrato(this.contratos, this.lista)

      if (this.numeroContrato) {
        return contratosMap.filter((v) => v.numeroContrato === this.numeroContrato)
      }

      return contratosMap
    },
    Json () {
      try {
        return JSON.parse(this.inputText)
      } catch (ignored) {
        return {}
      }
    },
    tituloNavegacao () {
      return this.funcionalidade.parametros.dashboard.nome
    },
    inputJson () {
      try {
        return JSON.parse(this.inputText)
      } catch (ignored) {
        return {}
      }
    }
  }
}
</script>
